<template>
  <ClientOnly>
    <div>
      <HeaderReferralButton v-if="!$auth.user.hasSeenNewReferProgram" />
      <HeaderMenuNotifications />
      <HeaderDirectMessages class="header-menu__messages" />
      <HeaderCommissionBalance />
      <HeaderMenuUser class="header-menu__profile" />
    </div>
  </ClientOnly>
</template>

<script>
import HeaderCommissionBalance from '@/components/global/Header/HeaderCommissionBalance/HeaderCommissionBalance';
import HeaderMenuNotifications from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotifications';
import HeaderDirectMessages from '@/components/global/Header/HeaderDirectMessages/HeaderDirectMessages';
import HeaderMenuUser from './HeaderMenuUser';

export default {
  name: 'HeaderMenuMember',
  components: {
    HeaderCommissionBalance,
    HeaderMenuNotifications,
    HeaderReferralButton: () => import('./HeaderReferral/HeaderReferralButton.vue'),
    HeaderMenuUser,
    HeaderDirectMessages,
  },
};
</script>

<style scoped lang="scss">
.header-menu {
  // display: flex;
  // align-items: center;

  &__profile {
    margin-left: 18px;
  }

  &__messages {
    margin-left: 13px;
  }
}
</style>
